<script setup>
import { useNuxtApp } from '#app'
import AlertIconDanger from '@/components/Icons/AlertIconDanger.vue'

const props = defineProps({
  error: Object,
})

const { $_ } = useNuxtApp()
</script>

<template>
  <div>
    <NuxtLayout name="default">
      <div class="d-flex flex-column justify-content-center align-items-center">
        <AlertIconDanger :default-fill="false" icon-class="fill-primary" class="mt-5" />
        <h1 class="mt-3 mb-1">{{ $_('pages/error.heading', 'Něco se pokazilo.') }}</h1>
        <p>
          {{ $_('pages/error.subheading.text', 'Tady bude nějaký text s odkazem kam může uživatel pokračovat') }}
          <a href="/dashboard" class="text-primary text-decoration-underline">
            {{ $_('pages/error.subheading.link', 'Odkaz na homepage.') }}
          </a>
        </p>
        <img v-if="error.statusCode === 404" class="w-50 mt-6" src="@/assets/images/404.png" alt="error" />
        <img v-else class="w-50 mt-6" src="@/assets/images/500.png" alt="error" />
        <a
          class="text-decoration-underline text-primary mt-6 mb-6"
          :href="'mailto:' + $_('pages/error.suppor_email', 'support@jrkdigital.eu')"
        >
          {{ $_('pages/error.suppor_email', 'support@jrkdigital.eu') }}
        </a>
      </div>
    </NuxtLayout>
  </div>
</template>
